import { stenaWeight } from "@stenajs-webui/elements";
import * as React from "react";
import { useFilterWorkspace } from "../../hooks/UseFilterWorkspace";
import { RangeFilter } from "../../types/RangeFilter";
import { FppSearchFilterSection } from "../FppSearchFilterSection";
import { RangeControl } from "../RangeControl";

interface Props {
  enabled?: boolean;
  label?: string;
  labelFrom?: string;
  labelTo?: string;
  maxDecimals?: number;
  maxNumbers?: number;
}

export const VehicleWeightFilterSection: React.FC<Props> = ({
  enabled,
  label,
  labelFrom,
  labelTo,
  maxDecimals,
  maxNumbers,
}) => {
  const { vehicleWeight, setVehicleWeight } = useFilterWorkspace();

  const onFilterValueChange = (rangeFilter: RangeFilter) => {
    setVehicleWeight({ ...rangeFilter });
  };

  const numberOfActiveFilters = () => {
    return vehicleWeight.from || vehicleWeight.to ? 1 : 0;
  };

  return (
    <FppSearchFilterSection
      sectionId={"vehicleWeight"}
      label={label}
      enabled={enabled}
      numSelected={numberOfActiveFilters()}
      leftIcon={stenaWeight}
      children={
        <RangeControl<RangeFilter>
          value={vehicleWeight}
          valueFrom={vehicleWeight.from}
          valueTo={vehicleWeight.to}
          onValueChange={onFilterValueChange}
          labelFrom={labelFrom ?? "From"}
          labelTo={labelTo ?? "To"}
          maxNumbers={maxNumbers}
          maxDecimals={maxDecimals}
        />
      }
    />
  );
};
